module.exports = __webpack_public_path__ + "img/body.6e6fc114.png";